module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/profile-256.3e170b1d3dde1148.png"+" 256w",
        images: [{path: "https://static.sniffspot.com/packs/img/profile-256.3e170b1d3dde1148.png",width: 256,height: 256}],
        src: "https://static.sniffspot.com/packs/img/profile-256.3e170b1d3dde1148.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/profile-256.3e170b1d3dde1148.png"},
        
        width: 256,
        height: 256
      }